import React, { FC } from "react"
import {
	Dialog,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	TrapFocusProps
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide"
import Close from "@material-ui/icons/Close"
import {useAuth} from 'src/common/razzle-platform-user/Authentication/hooks'
import Login from 'src/common/razzle-platform-user/Authentication/Login/Login'
import Register from 'src/common/razzle-platform-user/Authentication/Register/Register'
import Authorization from 'src/common/razzle-platform-user/Authentication/Authorization/Authorization'


const useStyles = makeStyles({
	section: {
		padding: "70px 0 0"
	},
	container: {
		paddingRight: "15px",
		paddingLeft: "15px",
		marginRight: "auto",
		marginLeft: "auto",
		width: "100%",
		"@media (min-width: 576px)": {
			maxWidth: "540px"
		},
		"@media (min-width: 768px)": {
			maxWidth: "720px"
		},
		"@media (min-width: 992px)": {
			maxWidth: "960px"
		},
		"@media (min-width: 1200px)": {
			maxWidth: "1140px"
		}
	},
	icon: {
		width: "17px",
		height: "17px",
		marginRight: "4px"
	},
	modal: {
		borderRadius: "6px"
	},
	modalHeader: {
		borderBottom: "none",
		paddingTop: "24px",
		paddingRight: "24px",
		paddingBottom: "0",
		paddingLeft: "24px",
		minHeight: "16.43px"
	},
	modalCloseButton: {
		color: "#999999",
		marginTop: "-12px",
		WebkitAppearance: "none",
		padding: "0",
		cursor: "pointer",
		background: "0 0",
		border: "0",
		fontSize: "inherit",
		opacity: ".9",
		textShadow: "none",
		fontWeight: 700,
		lineHeight: "1",
		float: "right"
	},
	modalClose: {
		width: "16px",
		height: "16px"
	},
	gridContainer: {
		marginRight: "-15px",
		marginLeft: "-15px",
		width: "auto"
	},
	gridItem: {
		position: "relative",
		width: "100%",
		minHeight: "1px",
		paddingRight: "15px",
		paddingLeft: "15px",
		flexBasis: "auto"
	}
});


const Transition: FC<any> = React.forwardRef<any, any>((props, ref) => {
	return <Slide direction="down" ref={ref} {...props} />
})


Transition.displayName = "Transition";

export default function AuthDialog(props) {
	const classes = useStyles();
	const { isAuthenticationDialogOpen, closeAuthenticationDialog, actions } = useAuth()


	return (
		<div className={classes.section}>
			<div className={classes.container}>
				<Grid container className={classes.gridContainer}>
					<Grid item xs={12} sm={12} md={6} className={classes.gridItem}>
						<Grid container className={classes.gridContainer}>
							<Grid item xs={12} sm={12} md={6} lg={4} className={classes.gridItem}>
								<Dialog
									style={{ zIndex: 13000 }}
									classes={{
										paper: classes.modal
									}}
									open={isAuthenticationDialogOpen}
									TransitionComponent={Transition}
									keepMounted
									onClose={() => closeAuthenticationDialog()}
									aria-labelledby="classic-modal-slide-title"
									aria-describedby="classic-modal-slide-description"
									maxWidth="xs"
								>
									<DialogTitle
										id="classic-modal-slide-title"
										disableTypography
										className={classes.modalHeader}
									>
										<IconButton
											className={classes.modalCloseButton}
											key="close"
											aria-label="Close"
											color="inherit"
											onClick={() => closeAuthenticationDialog()}
										>
											<Close className={classes.modalClose} />
										</IconButton>
									</DialogTitle>
									<DialogContent id="classic-modal-slide-description">
										{ actions.display === 'register' &&
											<Register
												textField={props.textField}
												passwordField={props.passwordField}
												checkBoxField={props.checkBoxField}
												submitButton={props.submitButton}
											/>
										}
										{ actions.display === 'login' &&
											<Login
												textField={props.textField}
												passwordField={props.passwordField}
												checkBoxField={props.checkBoxField}
												submitButton={props.submitButton}
											/>
										}
										{
											actions.display === 'authorization' && <Authorization />
										}
									</DialogContent>
								</Dialog>
							</Grid>
						</Grid>
					</Grid>
				</Grid>

			</div>
		</div>
	)
}
